// BOUNTY
export const FETCH_LOAD_BOUNTIES = 'FETCH_LOAD_BOUNTIES'
export const SET_LOAD_BOUNTIES = 'SET_LOAD_BOUNTIES'
export const FETCH_USER_BOUNTY_BUDGETS = 'FETCH_USER_BOUNTY_BUDGETS'
export const SET_USER_BOUNTY_BUDGETS = 'SET_USER_BOUNTY_BUDGETS'
export const UPDATE_USER_BOUNTY_BUDGET = 'UPDATE_USER_BOUNTY_BUDGET'
export const DELETE_LOAD_BOUNTY = 'DELETE_LOAD_BOUNTY'
export const SET_LOAD_BOUNTIES_FILTER = 'SET_LOAD_BOUNTIES_FILTER'
export const CLEAR_LOAD_BOUNTIES_FILTER = 'CLEAR_LOAD_BOUNTIES_FILTER'